var BackOffice = (function ($) {

    var modules = [];
    var isGodUser = {};

    var startupOptions = {
        //  Global selector used in js modules for specificity. 
        //  Can be overridden in-page by init call to page specific js module
        scopeSelector: $(".page-wrap")
    };

    var module = function (module) {
        if (!$.isPlainObject(module)) {
            throw new Error("Argument 'module' must be a an object with an init function member.");
        }

        $.extend(startupOptions, module.options);

        if (module.init instanceof Function) {
            invokeInit(module);
        }

        modules.push(module);
    };

    function init(options) {

        var promises = [];

        // Initialise all of the registered modules
        for (var i = 0; i < modules.length; i++) {
            invokeInit(modules[i]);
        }
    };

    function invokeInit(module) {
        if (module._initialised) {
            return undefined;
        }

        if (module.init instanceof Function) {
            return module.init();
        }

        module._initialised = true;
        return undefined;
    }

    var togglePageOverlay = function(toggle, timeoutMillis, overlayClass) {

        if (!overlayClass) {
            overlayClass = ".page-overlay"
        }

        var overlay = $(overlayClass);

        timeoutMillis = ( typeof timeoutMillis !== "undefined" ? timeoutMillis : 30000 );

        if (toggle) {
            overlay.addClass("active").show();
            var timeout = setTimeout(function() {
                overlay.removeClass("active").hide();
            }, timeoutMillis);
            overlay.data("timeout", timeout);

        } else {
            overlay.removeClass("active").hide();
            var timeout = overlay.data("timeout");

            if (timeout) {
                clearTimeout(timeout);
                overlay.removeData("timeout");
            }
        }
    };

    var exportToExcel = function (table, name) {
        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table cellspacing="0" rules="rows" border="1" style="color:Black;background-color:White;border-color:#CCCCCC;border-width:1px;border-style:None;width:100%;border-collapse:collapse;font-size:9pt;text-align:center;">{table}</table></body></html>';
        var base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))); };
        var format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }); };

        if (!table.nodeType) {
            table = document.getElementById(table);
        }
        var $table = $(table).clone(true);  // convert table to jquery object and clone so the orignal report is not manipulated
        $table.find("a").replaceWith("&nbsp;");
        $table.find("button").replaceWith("&nbsp;");
        var ctx = {
            worksheet: name || "Report Results",
            table: $table.html()
        }

        if (navigator.msSaveBlob) {
            var blob = new Blob([format(template, ctx)], { type: 'application/vnd.ms-excel', endings: 'native' });
            navigator.msSaveBlob(blob, name + '.xls');
        } else {
            var link = document.createElement("a");
            link.download = name + ".xls";
            link.href = uri + base64(format(template, ctx));
            document.body.appendChild(link);
            link.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
            link.remove();

        }
    };

    var removeNumberingIfOneListItemExists = function () {
        //   get ordered list and find how many list items exist. If only one, set formatting to remove numbering
        $("ol").each(function () {
            var $totalListItems = $(this).children().length;
            if ($totalListItems < 2) {
                $(this).addClass("noOrdering");
            }
        });
    };

    var displayErrorFromJScript = function (msg){
        var errPlaceHolder = $('[id$=ErrorList]');
        if (errPlaceHolder){
            errPlaceHolder.empty();

            var errHTML = "<div class='alert-info margin-small top right bottom left'>";
            errHTML += "<div class='errorPanel'><span style='color: red;'>";
            //errHTML += "<div class='container-fluid'><div class='row'><div class='col-sm-12'><div class='error-template'>";
            errHTML += "Oops! Sorry, an error has occured.";
            //errHTML += "<div class='error-actions'><a ui-sref='home' class='btn btn-primary btn-lg'><span class='glyphicon glyphicon-home'></span>Take Me Home </a></div>";
            errHTML += "</div>";
            errHTML += "</div>";
            //</div></div></div></div>";

            errPlaceHolder.prepend(errHTML);

        }
    };

    var setGodMode = function(isGodMode) {
        if (isGodMode === '')
            return isGodUser = "false";
        else
            return isGodUser = isGodMode;
    };

    var getGodMode = function() {
        return isGodUser;
    };

    return {
        options: startupOptions,
        SetGodMode: setGodMode,
        GetGodMode: getGodMode,
        ToggleLoader: togglePageOverlay,
        Module: module,
        ExportToExcel: exportToExcel,
        FormatSingleOrderedLists: removeNumberingIfOneListItemExists,
        DisplayErrorMessage: displayErrorFromJScript,
        Integration: {},
        Inventory: {}
    };

})(jQuery);
